import React, { useEffect, useState, useRef } from 'react';
import { Navigate, useParams, useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';

const AdminRoute = ({ children }) => {
  const { user, isLoading, tokenReady, signOutUser } = useAuth();
  const { slug } = useParams();
  const [isAllowed, setIsAllowed] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const navigate = useNavigate();
  const hasLoggedOut = useRef(false); 

  useEffect(() => {
    console.groupCollapsed('[AdminRoute] 🔐 Access Check Triggered');

    if (!tokenReady || isLoading) {
      console.groupEnd();
      return;
    }


    if (!user) {
      if (!hasLoggedOut.current) {
        console.warn('[AdminRoute] ❌ No user found – logging out');
        hasLoggedOut.current = true;
        signOutUser('[AdminRoute] No user');
      }
      setIsChecking(false);
      console.groupEnd();
      return;
    }

    if (user.role !== 'admin') {
      if (!hasLoggedOut.current) {
        console.warn('[AdminRoute] ❌ User is not an admin – logging out');
        hasLoggedOut.current = true;
        signOutUser('[AdminRoute] Invalid role');
      }
      setIsChecking(false);
      console.groupEnd();
      return;
    }

    if (!slug) {
      if (!hasLoggedOut.current) {
        console.warn('[AdminRoute] ❌ Missing slug – logging out');
        hasLoggedOut.current = true;
        signOutUser('[AdminRoute] Missing slug');
      }
      setIsChecking(false);
      console.groupEnd();
      return;
    }

    if (slug !== user.dashboardUrl) {
      console.warn('[AdminRoute] ⚠️ Slug mismatch:', {
        expected: user.dashboardUrl,
        received: slug
      });
      navigate(`/admin/${user.dashboardUrl}`, { replace: true });
      setIsChecking(false);
      console.groupEnd();
      return;
    }

    setIsAllowed(true);
    setIsChecking(false);
    console.groupEnd();
  }, [user, slug, isLoading, tokenReady, signOutUser, navigate]);

  if (isLoading || isChecking || !tokenReady) {
    return (
      <div className="flex items-center justify-center h-screen bg-white">
        <div className="flex flex-col items-center space-y-6">
          <img
            src="/assets/loading.gif"
            alt="Chargement"
            className="w-40 h-40"
          />
          <p className="text-2xl text-gray-700 font-semibold text-center">
            Vérification de l’accès administrateur…
          </p>
        </div>
      </div>
    );
  }

  if (!isAllowed) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};

export default AdminRoute;
